import { Component, forwardRef } from '@angular/core';
import { BaseFormComponent } from '../../../widgets/global/BaseFormComponent';
import { FormControl, Validators, NG_VALUE_ACCESSOR, FormGroup } from '@angular/forms';
import { RegexValidator } from 'src/app/validators/regex-validator'

export interface Pricing {
  value: string;
  viewValue: string;
}

@Component({
  standalone: false,
  selector: 'app-pricing-form',
  templateUrl: './pricing-form.component.html',
  styleUrls: ['./pricing-form.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => PricingFormComponent),
    multi: true
  }]
})
export class PricingFormComponent extends BaseFormComponent {


  pricingModels: Pricing[] = [
    { value: 'free', viewValue: 'Free Admission' },
    { value: 'paid', viewValue: 'Paid Admission' }
  ]

  constructor(private regexValidator: RegexValidator) {
    super();

    this.form = new FormGroup({
      admission: new FormControl('', [Validators.required]),
      
      generalAdmissionPrice : new FormControl('', [
        this.regexValidator.regexValidator(new RegExp('^(0|[1-9][0-9]*)(\.[0-9]+)?$'), { 'number':true})
      ])
    });


    this.onValueChanged(p => {
      this.setValues(p.admission as string, p.generalAdmissionPrice as string);
    });

    this.form.valueChanges.subscribe(values => {
      this.value.admission = values.admission;

      if(values.admission === "paid"){
        if(values.generalAdmissionPrice)
          this.value.generalAdmissionPrice = values.generalAdmissionPrice;
        else
          delete this.value['generalAdmissionPrice'];
      }
    });

    this.form.get('admission').valueChanges.subscribe(admissionVal => {

      if(admissionVal === 'free') {
        this.clearAdmissionPrices();
        this.form.get('generalAdmissionPrice').disable();
      }else{
        this.form.get('generalAdmissionPrice').enable();
      }

    });
  }

  clearAdmissionPrices() {
      if (this.form.get('generalAdmissionPrice').value) {
        this.form.get('generalAdmissionPrice').setValue(null);
        this.form.get('generalAdmissionPrice').updateValueAndValidity();
      }

      delete this.value['generalAdmissionPrice'];
  }

  setValues(admission: string, generalAdmissionPrice: string): void {
    this.form.get('admission').setValue(admission);
    this.form.get('generalAdmissionPrice').setValue(generalAdmissionPrice);
  }

}
